webpackJsonp([2],{

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INSTANCE; });
/* unused harmony export BASE_URL */
/* unused harmony export download */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var BASE_URL = location && (location.hostname === 'we.nowyu.com' || location.hostname === 'me.nowyu.com') ? location.protocol + '//api.nowyu.com/v1' : 'http://localhost:8080/v1';

var INSTANCE = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: BASE_URL });

function download(path, fileName) {
    return INSTANCE.get(path).then(function (response) {
        var mime = response.headers['content-type'];
        var data = response.data;

        return new Blob([data], { type: mime });
    }).then(function (blob) {
        var anchor = document.createElement('a');
        var objectUrl = window.URL.createObjectURL(blob);

        anchor.href = objectUrl;
        anchor.download = fileName;
        anchor.click();

        window.URL.revokeObjectURL(objectUrl);
    });
}



/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(340),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FooterNavigation__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FooterNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FooterNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainToolbar__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileProviderCard__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileProviderCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProfileProviderCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__me_ProfileConnections__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__me_ProfileConnections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__me_ProfileConnections__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__me_DatastoreConnections__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__me_DatastoreConnections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__me_DatastoreConnections__);






/* harmony default export */ __webpack_exports__["a"] = ({
    FooterNavigation: __WEBPACK_IMPORTED_MODULE_0__FooterNavigation___default.a,
    MainToolbar: __WEBPACK_IMPORTED_MODULE_1__MainToolbar___default.a,
    ProfileProviderCard: __WEBPACK_IMPORTED_MODULE_2__ProfileProviderCard___default.a,
    MeProfileConnections: __WEBPACK_IMPORTED_MODULE_3__me_ProfileConnections___default.a,
    MeDatastoreConnections: __WEBPACK_IMPORTED_MODULE_4__me_DatastoreConnections___default.a
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_auth__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meta_json__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meta_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__meta_json__);







/* eslint no-use-before-define: ["error", { "functions": false }] */
function fromRouteMap(routes) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(routes).map(function (element) {
        return fromRoute(element[0], element[1]);
    });
}

function fromRoute(path, meta) {
    var view = meta.title ? meta.title : 'NotFound';
    var page = meta.page ? meta.page : view;
    var redirect = meta.redirect;
    var result = {
        path: path,
        meta: meta
    };

    result.name = meta.name;
    result.showToolbar = meta.showToolbar || true;
    result.props = meta.props || false;
    if (page) {
        result.component = function () {
            return __webpack_require__(346)("./" + page + '.vue');
        };
    }

    if (redirect) {
        result.redirect = redirect;
    }

    if (meta.children) {
        result.children = fromRouteMap(meta.children);
    }

    return result;
}

function requiresAutoLogin(to) {
    // TODO: move this as prop into meta.json
    return to.path.startsWith('/requests');
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
var routes = fromRouteMap(__WEBPACK_IMPORTED_MODULE_5__meta_json___default.a);
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    saveScrollPosition: true,
    mode: 'history',
    routes: routes
});

router.beforeEach(function (to, from, next) {
    if (to.path !== '/login' && to.path !== '/login/callback' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_auth__["a" /* isAuthenticated */])()) {
        if (requiresAutoLogin(to)) {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('auth/AUTHORIZE', to.fullPath);
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath,
                    autoLogin: requiresAutoLogin(to)
                }
            });
        }
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_logger__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(196);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuejs_logger___default.a, {
    logLevel:  false ? 'debug' : 'info',
    // optional : defaults to false if not specified
    stringifyArguments: false,
    // optional : defaults to false if not specified
    showLogLevel: true
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */]).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component(key, __WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */][key]);
});

// sync the router with the vuex store.
// this registers `store.state.route`
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

// interesting ref on how to init security creds on app reload
// https://stackoverflow.com/questions/42579601/how-to-access-async-store-data-in-vue-router-for-usage-in-beforeenter-hook
__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('auth/INIT').then(function () {
    // create the app instance.
    // here we inject the router and store to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    /* eslint-disable no-new */
    new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
        render: function render(h) {
            return h(__WEBPACK_IMPORTED_MODULE_5__App___default.a);
        }
    });
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        redirect: undefined,
        issuer: {
            Id: undefined,
            Name: undefined,
            Picture: undefined
        },
        intent: undefined,
        consent: {
            Expiration: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'years').startOf('day').format('YYYY-MM-DD')
        },
        consents: undefined,
        filter: 'all'
    },
    getters: {
        issuer: function issuer(state) {
            return state.issuer;
        },
        intent: function intent(state) {
            return state.intent;
        },
        consent: function consent(state) {
            return state.consent;
        },
        redirect: function redirect(state) {
            return state.redirect;
        },
        isAcceptable: function isAcceptable(state) {
            return state.redirect && state.intent;
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        SAVE_CONSENTS: function SAVE_CONSENTS(state, data) {
            state.consents = data;
        },
        SAVE_PARAMS: function SAVE_PARAMS(state, _ref) {
            var issuer = _ref.issuer,
                intent = _ref.intent,
                redirect = _ref.redirect,
                consent = _ref.consent;

            if (issuer) state.issuer = issuer;
            if (intent) state.intent = intent;
            if (redirect) state.redirect = redirect;

            state.consent = consent || { Expiration: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'years').startOf('day').format('YYYY-MM-DD') };
        },
        UPDATE_EXPIRATION: function UPDATE_EXPIRATION(s, value) {
            if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(value).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()())) {
                s.consent.Expiration = s.consent.Expiration;
            } else {
                s.consent.Expiration = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).startOf('day').format('YYYY-MM-DD');
            }
        },
        FILTER: function FILTER(state, value) {
            state.filter = value;
        }
    },
    watch: {},
    actions: {
        LOAD_MY_CONSENTS: function LOAD_MY_CONSENTS(context) {
            var filter = context.state.filter;
            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/consents?filter=' + filter).then(function (response) {
                return context.commit('SAVE_CONSENTS', response.data);
            }).catch(function (error) {
                context.commit('SAVE_CONSENTS', []);
                context.commit('errors/ADD', error, { root: true });
            });
        },
        LOAD_MY_CONSENTS_FILTER: function LOAD_MY_CONSENTS_FILTER(context, filter) {
            if (filter !== context.state.filter) {
                /* eslint-disable no-console */
                console.log('filter changed from ', context.state.filter, ' to ', filter);
                context.commit('FILTER', filter);
                return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/consents?filter=' + filter).then(function (response) {
                    return context.commit('SAVE_CONSENTS', response.data);
                }).catch(function (error) {
                    context.commit('SAVE_CONSENTS', []);
                    context.commit('errors/ADD', error, { root: true });
                });
            }

            /* eslint-disable no-console */
            console.log('filter was not changed from ', filter);
            return null;
        },
        LOAD_CONSENT: function LOAD_CONSENT(context) {
            var issuerId = context.rootState.route.params.issuer;
            var intentCode = context.rootState.route.params.intent;
            var redirect = context.rootState.route.query.redirect || '/consents';

            var issuer = {
                Id: issuerId,
                Name: 'Your Provider',
                Picture: undefined
            };

            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/' + issuerId + '/intents/' + intentCode).then(function (response) {
                return context.commit('SAVE_PARAMS', { issuer: issuer, intent: response.data, redirect: redirect });
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        ACCEPT: function ACCEPT(context) {
            var issuerId = context.state.issuer.Id;
            var intentCode = context.state.intent.Code;
            var redirect = context.state.redirect;
            var consent = {
                Expiration: __WEBPACK_IMPORTED_MODULE_0_moment___default()(context.state.consent.Expiration).format()
            };

            var issuer = {
                Id: issuerId,
                Name: 'Your Provider',
                Picture: undefined
            };

            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].post('/' + issuerId + '/intents/' + intentCode + '/consent', consent).then(function (response) {
                return context.commit('SAVE_PARAMS', { issuer: issuer, intent: context.state.intent, redirect: redirect, consent: response.data });
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        REVOKE: function REVOKE(context) {
            var issuerId = context.state.issuer.Id;
            var intentCode = context.state.intent.Code;

            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].delete('/' + issuerId + '/intents/' + intentCode + '/consent').then(function () {
                return context.commit('SAVE_PARAMS', { consent: undefined });
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        }
    }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        providers: []
    },
    getters: {
        limitedProviderList: function limitedProviderList(s, count) {
            return s.providers.slice(0, s.providers.length >= count ? count : s.providers.length);
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST: function LIST(s, data) {
            s.providers = data;
        }
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL: function LIST_ALL(context) {
            return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/datastoreProviders').then(function (response) {
                return context.commit('LIST', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        }
    }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        errors: []
    },
    getters: {
        listErrors: function listErrors(state) {
            return state.errors;
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        CLEAR: function CLEAR(state) {
            state.errors = [];
        },
        ADD: function ADD(state, data) {
            state.errors.push(data);
        }
    },
    actions: {}
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        title: 'NowYu.ME',
        sidebar: true,
        currentColor: 'deep-purple',
        breadcrumbItems: [],
        route: undefined
    },
    getters: {
        showToolbar: function showToolbar(state) {
            return state.route ? state.route.showToolbar || false : false;
        },
        showFooter: function showFooter(state) {
            return (state.route && state.route.showFooter !== undefined ? state.route.showFooter : true) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__auth__["a" /* isAuthenticated */])();
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        TITLE: function TITLE(state, data) {
            state.title = data;
        },
        SIDEBAR: function SIDEBAR(state, data) {
            state.sidebar = data;
        },
        BREADCRUMBS: function BREADCRUMBS(state, data) {
            state.breadcrumbItems = data;
        },
        ROUTE: function ROUTE(state, data) {
            state.route = data;
            state.title = data.title;
        }
    },
    actions: {}
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(14);



var uuid = __webpack_require__(329);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        profileConnections: [],
        datastoreConnections: []
    },
    getters: {
        profileConnections: function profileConnections(state) {
            return state.profileConnections;
        },
        datastoreConnections: function datastoreConnections(state) {
            return state.datastoreConnections;
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        PROFILE_CONNECTIONS: function PROFILE_CONNECTIONS(state, data) {
            state.profileConnections = data || [];
        },
        PROFILE_CONNECTION: function PROFILE_CONNECTION(state, data) {
            var replaced = false;
            for (var i = 0; i < state.profileConnections.length; i += 1) {
                if (state.profileConnections[i].ProfileProviderId === data.ProfileProviderId) {
                    state.profileConnections[i] = data;
                    replaced = true;
                }
            }
            if (!replaced) {
                if (state.profileConnections) {
                    state.profileConnections.push(data);
                } else {
                    state.profileConnections = [data];
                }
            }
        },
        DATASTORE_CONNECTIONS: function DATASTORE_CONNECTIONS(state, data) {
            state.datastoreConnections = data || [];
        },
        DATASTORE_CONNECTION: function DATASTORE_CONNECTION(state, data) {
            var replaced = false;
            for (var i = 0; i < state.datastoreConnections.length; i += 1) {
                if (state.datastoreConnections[i].DataStoreProviderId === data.DataStoreProviderId) {
                    state.datastoreConnections[i] = data;
                    replaced = true;
                }
            }
            if (!replaced) {
                if (state.datastoreConnections) {
                    state.datastoreConnections.push(data);
                } else {
                    state.datastoreConnections = [data];
                }
            }
        },
        AUTHORIZE_CONNECTION: function AUTHORIZE_CONNECTION(state, data) {
            var provider = data.provider;
            var type = data.type;
            var connectionState = uuid();
            var baseUrl = provider.AuthorizeUrl.replace('https://me.nowyu.com', decodeURI(location.origin));
            var url = baseUrl + '&state=' + connectionState;
            var redirectUri = provider.RedirectUri.replace('https://me.nowyu.com', decodeURI(location.origin));

            localStorage.setItem('oauth.' + provider.Code, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Type: type, State: connectionState, RedirectUri: redirectUri }));

            window.location = url;
        }
    },
    actions: {
        LIST_PROFILE_CONNECTIONS: function LIST_PROFILE_CONNECTIONS(context) {
            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profile/profile_connections').then(function (response) {
                return context.commit('PROFILE_CONNECTIONS', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        LIST_DATASTORE_CONNECTIONS: function LIST_DATASTORE_CONNECTIONS(context) {
            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].get('/profile/datastore_connections').then(function (response) {
                return context.commit('DATASTORE_CONNECTIONS', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        SAVE_CONNECTION: function SAVE_CONNECTION(context, data) {
            if (data.Query.error) {
                throw Error(data.Query.error_description, data.Query.error);
            }

            var session = JSON.parse(localStorage.getItem('oauth.' + data.ProviderId));
            if (!session) {
                throw new Error('No session authorization information found for ' + data.ProviderId);
            }

            var connection = data.Query;
            if (!connection.state && connection.state !== session.State) {
                throw new Error('Invalid session authorization information found for ' + data.ProviderId);
            }

            connection.DataOwnerId = context.rootGetters['auth/userId'];
            connection.RedirectUri = session.RedirectUri;
            connection.State = session.State;

            var url = void 0;
            switch (session.Type) {
                case 'profile':
                    connection.ProfileProviderId = data.ProviderId;
                    url = 'profile/profile_connections';
                    break;
                case 'datastore':
                    connection.DataStoreProviderId = data.ProviderId;
                    url = 'profile/datastore_connections';
                    break;
                default:
                    throw new Error('unknow provider type! was ' + data.ProviderType);
            }

            return __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].put(url, connection).then(function (response) {
                return context.commit('DATASTORE_CONNECTION', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        },
        AUTHORIZE_DATASTORE_CONNECTION: function AUTHORIZE_DATASTORE_CONNECTION(context, provider) {
            context.commit('AUTHORIZE_CONNECTION', { provider: provider, type: 'datastore' });
        },
        AUTHORIZE_PROFILE_CONNECTION: function AUTHORIZE_PROFILE_CONNECTION(context, provider) {
            context.commit('AUTHORIZE_CONNECTION', { provider: provider, type: 'profile' });
        }
    }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        providers: []
    },
    getters: {
        limitedProviderList: function limitedProviderList(s, count) {
            return s.providers.slice(0, s.providers.length >= count ? count : s.providers.length);
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST: function LIST(s, data) {
            s.providers = data;
        }
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL: function LIST_ALL(context) {
            return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/profileProviders').then(function (response) {
                return context.commit('LIST', response.data);
            }).catch(function (error) {
                return context.commit('errors/ADD', error, { root: true });
            });
        }
    }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        MainLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_MainLayout___default.a
    },
    data: function data() {
        return {
            // screen title
            title: 'NowYu.WE'
        };
    },

    watch: {
        /* eslint-disable object-shorthand */
        '$route': function $route(to, from) {
            this.setMeta(to, from);
        }
    },
    methods: {
        setMeta: function setMeta(to) {
            if (typeof document === 'undefined') return;

            document.title = to.meta.window_title;
            this.$store.commit('nav/ROUTE', to.meta);
        }
    }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'footer-navigation',
    computed: {
        current: {
            //eslint-disable-next-line
            get: function get() {
                return this.$store.state.route.name;
            },
            //eslint-disable-next-line
            set: function set(v) {
                this.$router.push({ name: v });
            }
        }
    },
    methods: {}
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MainToolbar',
    computed: {},
    methods: {
        back: function back() {
            this.$router.go(-1);
        }
    }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProfileProviderCard',
    props: ['provider'],
    data: function data() {
        return {};
    },

    computed: {},
    methods: {},
    created: function created() {}
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_time__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'me-datastore-connections',
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('datastoreProviders', ['limitedProviderList']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('profile', ['datastoreConnections'])),
    methods: {
        statusClass: function statusClass(providerCode) {
            var connection = this.connection(providerCode);
            if (connection && connection.RequiresReauthentication) {
                return 'status important';
            }

            return 'status';
        },
        status: function status(providerCode) {
            var connection = this.connection(providerCode);
            if (!connection) {
                return 'not connected';
            }

            if (connection.RequiresReauthentication) {
                return 'requires reauthentication';
            }

            if (connection.AccessTokenExpiration) {
                if (connection.AccessTokenExpiration === '0001-01-01T00:00:00Z') {
                    return 'never expires';
                }

                return 'expires on ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_time__["a" /* default */])(connection.AccessTokenExpiration);
            }

            return 'connected';
        },
        connection: function connection(providerCode) {
            for (var i = 0; i < this.datastoreConnections.length; i += 1) {
                var connection = this.datastoreConnections[i];
                if (connection.DataStoreProviderId === providerCode) {
                    return connection;
                }
            }

            return undefined;
        },
        linkProvider: function linkProvider(providerCode) {
            var provider = this.limitedProviderList.find(function (element) {
                return element.Code === providerCode;
            });

            if (provider) {
                this.$store.dispatch('profile/AUTHORIZE_DATASTORE_CONNECTION', provider);
            } else {
                var error = new Error('Provider with code ' + providerCode + ' was not found in limited list of profile providers!');
                this.$store.dispatch('errors/ADD', error);
            }
        }
    },
    created: function created() {
        this.$store.dispatch('profile/LIST_DATASTORE_CONNECTIONS');
        this.$store.dispatch('datastoreProviders/LIST_ALL');
    }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_time__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'me-profile-connections',
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('profileProviders', ['limitedProviderList']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('profile', ['profileConnections'])),
    methods: {
        statusClass: function statusClass(providerCode) {
            var connection = this.profileConnection(providerCode);
            if (connection && connection.RequiresReauthentication) {
                return 'status important';
            }

            return 'status';
        },
        status: function status(providerCode) {
            var connection = this.profileConnection(providerCode);
            if (!connection) {
                return 'not connected';
            }

            if (connection.RequiresReauthentication) {
                return 'requires reauthentication';
            }

            if (connection.AccessTokenExpiration) {
                if (connection.AccessTokenExpiration === '0001-01-01T00:00:00Z') {
                    return 'never expires';
                }

                return 'expires on ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_time__["a" /* default */])(connection.AccessTokenExpiration);
            }

            return 'connected';
        },
        profileConnection: function profileConnection(providerCode) {
            for (var i = 0; i < this.profileConnections.length; i += 1) {
                var connection = this.profileConnections[i];
                if (connection.ProfileProviderId === providerCode) {
                    return connection;
                }
            }

            return undefined;
        },
        linkProfile: function linkProfile(providerCode) {
            var provider = this.limitedProviderList.find(function (element) {
                return element.Code === providerCode;
            });

            if (provider) {
                this.$store.dispatch('profile/AUTHORIZE_PROFILE_CONNECTION', provider);
            } else {
                var error = new Error('Provider with code ' + providerCode + ' was not found in limited list of profile providers!');
                this.$store.dispatch('errors/ADD', error);
            }
        }
    },
    created: function created() {
        this.$store.dispatch('profile/LIST_PROFILE_CONNECTIONS');
        this.$store.dispatch('profileProviders/LIST_ALL');
    }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainToolbar__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MainToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterNavigation__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterNavigation__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showSnackbar: false,
            snackbarText: '',
            snackbarTimeout: 10000,
            snackbarBottom: true,
            snackbarColor: 'success',
            snackbarMode: ''
        };
    },

    components: {
        FooterNavigation: __WEBPACK_IMPORTED_MODULE_4__components_FooterNavigation___default.a,
        MainToolbar: __WEBPACK_IMPORTED_MODULE_3__components_MainToolbar___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('nav', ['showToolbar', 'showFooter']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])('errors', ['errors']), {
        showError: function showError(errors) {
            var msg = '';
            if (errors && errors.length > 0) {
                var error = errors[errors.length - 1];
                this.$log.error(error);

                if (error.response) {
                    msg = error.response.data;
                } else if (error.message) {
                    msg = error.message;
                } else {
                    msg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error);
                }
            }

            this.snack(msg, 'error');
        },
        snack: function snack(msg, color) {
            this.snackbarText = msg;
            this.snackbarColor = color;
            this.snackbarMode = msg && msg.length > 100 ? 'multi-line' : '';
            this.showSnackbar = msg !== '';
        },
        errorsChanged: function errorsChanged(oldValue, newValue) {
            this.showError(newValue);
        }
    }),
    created: function created() {
        var _this = this;

        this.$store.watch(function (state) {
            _this.$log.debug('state');
            return state.errors.errors;
        }, this.errorsChanged);
    }
});

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 73,
	"./af.js": 73,
	"./ar": 80,
	"./ar-dz": 74,
	"./ar-dz.js": 74,
	"./ar-kw": 75,
	"./ar-kw.js": 75,
	"./ar-ly": 76,
	"./ar-ly.js": 76,
	"./ar-ma": 77,
	"./ar-ma.js": 77,
	"./ar-sa": 78,
	"./ar-sa.js": 78,
	"./ar-tn": 79,
	"./ar-tn.js": 79,
	"./ar.js": 80,
	"./az": 81,
	"./az.js": 81,
	"./be": 82,
	"./be.js": 82,
	"./bg": 83,
	"./bg.js": 83,
	"./bn": 84,
	"./bn.js": 84,
	"./bo": 85,
	"./bo.js": 85,
	"./br": 86,
	"./br.js": 86,
	"./bs": 87,
	"./bs.js": 87,
	"./ca": 88,
	"./ca.js": 88,
	"./cs": 89,
	"./cs.js": 89,
	"./cv": 90,
	"./cv.js": 90,
	"./cy": 91,
	"./cy.js": 91,
	"./da": 92,
	"./da.js": 92,
	"./de": 95,
	"./de-at": 93,
	"./de-at.js": 93,
	"./de-ch": 94,
	"./de-ch.js": 94,
	"./de.js": 95,
	"./dv": 96,
	"./dv.js": 96,
	"./el": 97,
	"./el.js": 97,
	"./en-au": 98,
	"./en-au.js": 98,
	"./en-ca": 99,
	"./en-ca.js": 99,
	"./en-gb": 100,
	"./en-gb.js": 100,
	"./en-ie": 101,
	"./en-ie.js": 101,
	"./en-nz": 102,
	"./en-nz.js": 102,
	"./eo": 103,
	"./eo.js": 103,
	"./es": 105,
	"./es-do": 104,
	"./es-do.js": 104,
	"./es.js": 105,
	"./et": 106,
	"./et.js": 106,
	"./eu": 107,
	"./eu.js": 107,
	"./fa": 108,
	"./fa.js": 108,
	"./fi": 109,
	"./fi.js": 109,
	"./fo": 110,
	"./fo.js": 110,
	"./fr": 113,
	"./fr-ca": 111,
	"./fr-ca.js": 111,
	"./fr-ch": 112,
	"./fr-ch.js": 112,
	"./fr.js": 113,
	"./fy": 114,
	"./fy.js": 114,
	"./gd": 115,
	"./gd.js": 115,
	"./gl": 116,
	"./gl.js": 116,
	"./gom-latn": 117,
	"./gom-latn.js": 117,
	"./he": 118,
	"./he.js": 118,
	"./hi": 119,
	"./hi.js": 119,
	"./hr": 120,
	"./hr.js": 120,
	"./hu": 121,
	"./hu.js": 121,
	"./hy-am": 122,
	"./hy-am.js": 122,
	"./id": 123,
	"./id.js": 123,
	"./is": 124,
	"./is.js": 124,
	"./it": 125,
	"./it.js": 125,
	"./ja": 126,
	"./ja.js": 126,
	"./jv": 127,
	"./jv.js": 127,
	"./ka": 128,
	"./ka.js": 128,
	"./kk": 129,
	"./kk.js": 129,
	"./km": 130,
	"./km.js": 130,
	"./kn": 131,
	"./kn.js": 131,
	"./ko": 132,
	"./ko.js": 132,
	"./ky": 133,
	"./ky.js": 133,
	"./lb": 134,
	"./lb.js": 134,
	"./lo": 135,
	"./lo.js": 135,
	"./lt": 136,
	"./lt.js": 136,
	"./lv": 137,
	"./lv.js": 137,
	"./me": 138,
	"./me.js": 138,
	"./mi": 139,
	"./mi.js": 139,
	"./mk": 140,
	"./mk.js": 140,
	"./ml": 141,
	"./ml.js": 141,
	"./mr": 142,
	"./mr.js": 142,
	"./ms": 144,
	"./ms-my": 143,
	"./ms-my.js": 143,
	"./ms.js": 144,
	"./my": 145,
	"./my.js": 145,
	"./nb": 146,
	"./nb.js": 146,
	"./ne": 147,
	"./ne.js": 147,
	"./nl": 149,
	"./nl-be": 148,
	"./nl-be.js": 148,
	"./nl.js": 149,
	"./nn": 150,
	"./nn.js": 150,
	"./pa-in": 151,
	"./pa-in.js": 151,
	"./pl": 152,
	"./pl.js": 152,
	"./pt": 154,
	"./pt-br": 153,
	"./pt-br.js": 153,
	"./pt.js": 154,
	"./ro": 155,
	"./ro.js": 155,
	"./ru": 156,
	"./ru.js": 156,
	"./sd": 157,
	"./sd.js": 157,
	"./se": 158,
	"./se.js": 158,
	"./si": 159,
	"./si.js": 159,
	"./sk": 160,
	"./sk.js": 160,
	"./sl": 161,
	"./sl.js": 161,
	"./sq": 162,
	"./sq.js": 162,
	"./sr": 164,
	"./sr-cyrl": 163,
	"./sr-cyrl.js": 163,
	"./sr.js": 164,
	"./ss": 165,
	"./ss.js": 165,
	"./sv": 166,
	"./sv.js": 166,
	"./sw": 167,
	"./sw.js": 167,
	"./ta": 168,
	"./ta.js": 168,
	"./te": 169,
	"./te.js": 169,
	"./tet": 170,
	"./tet.js": 170,
	"./th": 171,
	"./th.js": 171,
	"./tl-ph": 172,
	"./tl-ph.js": 172,
	"./tlh": 173,
	"./tlh.js": 173,
	"./tr": 174,
	"./tr.js": 174,
	"./tzl": 175,
	"./tzl.js": 175,
	"./tzm": 177,
	"./tzm-latn": 176,
	"./tzm-latn.js": 176,
	"./tzm.js": 177,
	"./uk": 178,
	"./uk.js": 178,
	"./ur": 179,
	"./ur.js": 179,
	"./uz": 181,
	"./uz-latn": 180,
	"./uz-latn.js": 180,
	"./uz.js": 181,
	"./vi": 182,
	"./vi.js": 182,
	"./x-pseudo": 183,
	"./x-pseudo.js": 183,
	"./yo": 184,
	"./yo.js": 184,
	"./zh-cn": 185,
	"./zh-cn.js": 185,
	"./zh-hk": 186,
	"./zh-hk.js": 186,
	"./zh-tw": 187,
	"./zh-tw.js": 187
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(337),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(335),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42aa47c5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(336),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-529c01da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-bottom-nav', {
    staticClass: "mildly_purple",
    attrs: {
      "value": true,
      "active": _vm.current
    },
    on: {
      "update:active": function($event) {
        _vm.current = $event
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "value": "me"
    }
  }, [_c('span', [_vm._v("me")]), _vm._v(" "), _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "value": "discover"
    }
  }, [_c('span', [_vm._v("discover")]), _vm._v(" "), _c('v-icon', [_vm._v("dashboard")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "value": "vault"
    }
  }, [_c('span', [_vm._v("Vault")]), _vm._v(" "), _c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "value": "consents"
    }
  }, [_c('span', [_vm._v("Consents")]), _vm._v(" "), _c('v-icon', [_vm._v("swap_calls")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-group', {
    attrs: {
      "value": "true"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Link your personal data vault")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _vm._l((_vm.limitedProviderList), function(provider) {
    return _c('v-list-tile', {
      key: provider.Code,
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.linkProvider(provider.Code)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: [provider.Code]
    }, [_vm._v("\n                    fa-" + _vm._s(provider.Code) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(provider.Name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('div', {
      class: _vm.statusClass(provider.Code)
    }, [_vm._v(_vm._s(_vm.status(provider.Code)))])])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-group', {
    attrs: {
      "value": "true"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Boost your profile")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _vm._l((_vm.limitedProviderList), function(provider) {
    return _c('v-list-tile', {
      key: provider.Code,
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.linkProfile(provider.Code)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: [provider.Code]
    }, [_vm._v("\n                    fa-" + _vm._s(provider.Code) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(provider.Name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('div', {
      class: _vm.statusClass(provider.Code)
    }, [_vm._v(_vm._s(_vm.status(provider.Code)))])])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    on: {
      "click": function($event) {
        _vm.$emit('select')
      }
    }
  }, [_c('v-card-media', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100px",
      "max-height": "100px",
      "margin": "20px"
    },
    attrs: {
      "src": _vm.provider.Logo
    }
  })]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('span', [_vm._v(_vm._s(_vm.provider.Name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("compare_arrows")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "nowyu",
      "fixedFooter": ""
    }
  }, [(_vm.showToolbar()) ? _c('main-toolbar') : _vm._e(), _vm._v(" "), _c('main', {
    staticStyle: {
      "padding-bottom": "56px"
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    staticClass: "notification",
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "bottom": _vm.snackbarBottom,
      "success": _vm.snackbarColor === 'success',
      "info": _vm.snackbarColor === 'info',
      "warning": _vm.snackbarColor === 'warning',
      "error": _vm.snackbarColor === 'error',
      "primary": _vm.snackbarColor === 'primary',
      "secondary": _vm.snackbarColor === 'secondary',
      "multi-line": _vm.snackbarMode === 'multi-line',
      "vertical": _vm.snackbarMode === 'vertical'
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarText) + "\n        "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snack('', '')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.showFooter()) ? _c('footer-navigation') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout')
},staticRenderFns: []}

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_auth0_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth0_json__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth0_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__auth0_json__);







var callbackUrl = __WEBPACK_IMPORTED_MODULE_5__auth0_json___default.a.callbackUrl;
if (location) {
    callbackUrl = location.origin + '/login/callback';
}

/* eslint-disable no-underscore-dangle */
__WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var originalRequest = error.config;

    // if the error is 401 and hasn't already been retried
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        // mark our retry
        originalRequest._retry = true;

        // if we do a router.push() here, the whole app fails to load?
        // How comes???!!!
        window.location.path = '/login?redirect=' + window.location.href + '&autologin=true';
        // reauthenticate
        // router.push({
        //     path: '/login',
        //     query: {
        //         redirect: router.currentRoute.fullPath,
        //         autologin: true,
        //     },
        // });
    }

    // Do something with response error
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

function getItem(key) {
    var item = localStorage.getItem(key);

    if (item === 'undefined') {
        return undefined;
    }

    return item;
}

function setItem(key, value) {
    if (value) {
        localStorage.setItem(key, value);
    } else {
        localStorage.removeItem(key);
    }
}

function removeItem(key) {
    localStorage.removeItem(key);
}

/* eslint-disable no-param-reassign */
var utils = {
    saveLoginInfo: function saveLoginInfo(state, data) {
        state.auth = data;

        if (data && data.idToken) {
            state.profile = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(data.idToken);
        } else {
            state.profile = undefined;
        }

        __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].defaults.headers.common.Authorization = 'Bearer ' + data.accessToken;

        setItem('accessToken', data.accessToken);
        setItem('idToken', data.idToken);
        setItem('expiresAt', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.expiresAt));
    },
    clearLoginInfo: function clearLoginInfo(state) {
        removeItem('accessToken');
        removeItem('idToken');
        removeItem('expiresAt');

        // clear auth info from state
        state.auth = undefined;
        state.profile = undefined;

        __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].defaults.headers.common.Authorization = undefined;
    },
    restoreLoginInfo: function restoreLoginInfo() {
        if (getItem('accessToken')) {
            // get security info from localstorage
            var accessToken = getItem('accessToken');
            var idToken = getItem('idToken');
            var expiresAt = JSON.parse(getItem('expiresAt'));

            return {
                accessToken: accessToken,
                idToken: idToken,
                expiresAt: expiresAt
            };
        }

        return undefined;
    }
};

function isAuthenticated() {
    return getItem('accessToken') && new Date().getTime() < getItem('expiresAt');
}

var AUTH = {
    namespaced: true,
    state: {
        auth: undefined,
        auth0: new __WEBPACK_IMPORTED_MODULE_2_auth0_js___default.a.WebAuth({
            domain: __WEBPACK_IMPORTED_MODULE_5__auth0_json___default.a.domain,
            clientID: __WEBPACK_IMPORTED_MODULE_5__auth0_json___default.a.clientId,
            redirectUri: callbackUrl,
            audience: __WEBPACK_IMPORTED_MODULE_5__auth0_json___default.a.audience,
            responseType: __WEBPACK_IMPORTED_MODULE_5__auth0_json___default.a.responseType,
            scope: __WEBPACK_IMPORTED_MODULE_5__auth0_json___default.a.scope
        }),
        profile: undefined
    },
    getters: {
        authService: function authService(state) {
            return state.authService;
        },
        profile: function profile(state) {
            return state.profile;
        },
        authHeader: function authHeader(state) {
            if (state.auth) {
                return {
                    Authorization: 'Bearer ' + state.auth.accessToken
                };
            }

            return undefined;
        },

        // organisationId(state) {
        //     return state.profile ? state.profile.sub : undefined;
        // },
        userId: function userId(state) {
            return state.profile ? state.profile.sub : undefined;
        }
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        SAVE_AUTH: function SAVE_AUTH(state, data) {
            utils.saveLoginInfo(state, data);
        },
        LOGOUT: function LOGOUT(state) {
            utils.clearLoginInfo(state);
        },
        AUTHORIZE: function AUTHORIZE(state, redirect) {
            if (!isAuthenticated()) {
                // save redirect in local storage to revive after return from Auth0
                setItem('redirect', redirect || '/');

                utils.clearLoginInfo(state);
                state.auth0.authorize();
            }
        }
    },
    actions: {
        LOGIN: function LOGIN(context) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                context.state.auth0.parseHash(function (err, authResult) {
                    if (authResult && authResult.accessToken && authResult.idToken) {
                        context.commit('SAVE_AUTH', {
                            accessToken: authResult.accessToken,
                            idToken: authResult.idToken,
                            expiresAt: authResult.expiresIn * 1000 + new Date().getTime()
                        });

                        // revive redirect url from local storage
                        var redirect = getItem('redirect');
                        removeItem('redirect');

                        resolve(redirect);
                    } else if (err) {
                        reject(err);
                    }
                });
            });
        },
        INIT: function INIT(context) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var loginInfo = utils.restoreLoginInfo();
                if (loginInfo) {
                    context.commit('SAVE_AUTH', loginInfo);
                }
                resolve(true);
            });
        }
    }
};



/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    ref: "main-toolbar",
    staticClass: "primary",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("\n            arrow_back\n        ")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "relative"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.nav.title)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Callback.vue": 351,
	"./CallbackProvider.vue": 352,
	"./Consent.vue": 353,
	"./ConsentRequest.vue": 354,
	"./Consents.vue": 355,
	"./Discover.vue": 356,
	"./Login.vue": 357,
	"./Me.vue": 358,
	"./NotFound.vue": 359,
	"./Settings.vue": 360,
	"./Vault.vue": 361
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e/* lazy-once context */(0).then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 346;

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

module.exports = {"/me":{"name":"me","title":"Me","page":"Me","window_title":"NowYu.ME"},"/discover":{"name":"discover","title":"Discover","page":"Discover","window_title":"NowYu.ME - Discover opportunities"},"/vault":{"name":"vault","title":"Vault","page":"Vault","window_title":"NowYu.ME - Profile vault"},"/settings":{"name":"settings","title":"Settings","window_title":"NowYu.ME - Manage your settings"},"/login":{"name":"login","title":"Login","window_title":"NowYu.ME - Login"},"/login/callback":{"name":"callback","title":"Login callback","window_title":"NowYu.ME - Login callback","page":"Callback"},"/login/callback/:provider":{"name":"CallbackProvider","title":"Authorization callback from provider","window_title":"NowYu.ME - Authorization callback","page":"CallbackProvider","props":true},"/consents":{"name":"consents","title":"Consents","page":"Consents","window_title":"NowYu.ME - Consent requests","showToolbar":true},"/consents/:issuer/:intent":{"name":"Consent","title":"Consent details","page":"Consent","window_title":"NowYu.ME - Consent details","showToolbar":true},"/requests/:issuer/:intent":{"name":"ConsentRequest","title":"Consent request","page":"ConsentRequest","window_title":"NowYu.ME - Consent request","showFooter":false},"/":{"name":"home","redirect":"/me"},"*":{"name":"NotFound","title":"Not Found","window_title":"NowYu.ME - Not found","page":"NotFound","showToolbar":false,"showFooter":true}}

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

module.exports = {"domain":"nowyu.eu.auth0.com","clientId":"dQ1UkbUDa1dT3tJZBw0vGFCKFoAx05kI","callbackUrl":"https://me.nowyu.com/login/callback","audience":"api.nowyu.com","responseType":"token id_token","scope":"openid email profile"}

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nav__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consents__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profileProviders__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datastoreProviders__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__profile__ = __webpack_require__(247);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = true;

var debug = "production" !== 'production';
var modules = {
    auth: __WEBPACK_IMPORTED_MODULE_3__auth__["b" /* default */],
    errors: __WEBPACK_IMPORTED_MODULE_4__errors__["a" /* default */],
    nav: __WEBPACK_IMPORTED_MODULE_5__nav__["a" /* default */],
    consents: __WEBPACK_IMPORTED_MODULE_6__consents__["a" /* default */],
    profileProviders: __WEBPACK_IMPORTED_MODULE_7__profileProviders__["a" /* default */],
    datastoreProviders: __WEBPACK_IMPORTED_MODULE_8__datastoreProviders__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_9__profile__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
    modules: modules,
    strict: debug,
    plugins: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()()] : []
}));

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userReadable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function userReadable(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('LLL');
}

/***/ })

},[242]);


// WEBPACK FOOTER //
// static/js/app.1e61cb8ade48dfb8ee04.js